function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { Component } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import LayoutGrid from "../Layout/LayoutGrid";
const useStyles = makeStyles(theme => ({
  root: {
    padding: props => {
      return theme.spacing(props.padding);
    }
  }
}));

const ModuleBody = (_ref) => {
  let className = _ref.className,
      format = _ref.format,
      _ref$grid = _ref.grid,
      grid = _ref$grid === void 0 ? false : _ref$grid,
      _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? 2 : _ref$padding,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["className", "format", "grid", "padding", "children"]);

  const classes = useStyles({
    padding
  });
  return React.createElement("div", {
    className: className || classes.root
  }, React.createElement(LayoutGrid, _extends({
    grid: grid
  }, props), children));
};

export default ModuleBody;